import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Stack, Text } from '@travel-frontend/core';
import { Attributes } from '../../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/SupplierAttributes/components/Attributes/index.js';
export const Section = ({
  title,
  amenities = []
}) => {
  if (amenities.length === 0) {
    return null;
  }
  return _jsxs(Stack, {
    space: "headlines/medium",
    children: [title && _jsx(Text, {
      preset: "headlineSmall",
      children: title
    }), _jsx(Attributes, {
      data: amenities
    })]
  });
};